const styles = theme => ({
    root: {
        marginTop: theme.spacing(1),
        [theme.breakpoints.up(980)]: {
            marginTop: -theme.spacing(1) * 2,
        },
    },
    container: {
        maxWidth: 960,
        margin: 'auto',
        [theme.breakpoints.up(600)]: {
            paddingLeft: 16,
            paddingRight: 16,
        },
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        background: theme.paper ? theme.paper.background : '#f9f9f9',
        minHeight: '83vh',
        [theme.breakpoints.up(600)]: {
            minHeight: '813px',
        },
        fontFamily: theme.fontFamily + '!important',
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(1) + 'px!important',
        [theme.breakpoints.up(600)]: {
            padding: theme.spacing(4),
            paddingTop: theme.spacing(4) + 'px!important',
            paddingBottom: theme.spacing(1) + 'px!important',
        },
        boxShadow: theme.paper ? theme.paper.boxShadow : null,
        marginBottom: theme.paper ? theme.paper.marginBottom : theme.spacing(3),
        paddingTop: theme.paper ? theme.paper.paddingTop : theme.spacing(3) + 'px!important',
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
    },
    imageWrapper: {
        display: 'block',
        textAlign: 'center',
        padding: theme.spacing(1),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.up(980)]: {
            paddingTop: theme.spacing(8),
        },
        [theme.breakpoints.up(1400)]: {
            display: 'none',
        },
    },
    image: {
        maxWidth: '100%',
    },
    elementItem: {
        paddingBottom: 1,
    },
    title: {
        marginTop: theme.spacing(0) + 'px!important',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up(980)]: {
            marginTop: theme.spacing(4) + 'px!important',
        },
    },
    description: {
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up(980)]: {
            marginBottom: theme.spacing(4),
        },
    },
    buttonWrapper: {
        textAlign: 'center',
        display: 'block',
    },
    button: {
        color: '#ffffff',
        //width: '100%!important',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important',
        //maxWidth: 150,
        minWidth: '140px!important',
        lineHeight: '15px',
        padding: '0 20px',
        marginBottom: 40,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius + 'px!important' : 32,
    },
    rightIcon: {
        marginLeft: 16,
        marginTop: -3,
    },
});

export {styles};
